/* eslint-disable import/prefer-default-export */
import { maskPhone } from '../../utils/phone/maskPhone';
import { canUserSeeFullPhone } from '../../policies/user/phoneVisibilityPolicy';

export const getVisiblePhone = ({ phone, user }) => maskPhone({
  phone,
  canSeeFullPhone: canUserSeeFullPhone(user),
  visibleDigits: 3
});
